import { FC } from 'react'
import { Field, FieldProps, getIn } from 'formik'
import { Form } from 'antd'
import { FormItemProps as $FormItemProps } from 'antd/lib/form/FormItem'
import classNames from 'classnames'

export type FormItemProps = { children: React.ReactNode } & {
  name: string
  validate?: boolean
} & $FormItemProps

export const FormItem: FC<FormItemProps> = ({ name, children, validate, ...restProps }) => (
  <Field name={name} validate={validate}>
    {({ form: { errors, touched } }: FieldProps) => {
      const error = getIn(errors, name)
      const isTouched = getIn(touched, name, false) !== undefined && getIn(touched, name, false) !== null
      const hasError = error !== undefined && isTouched

      return (
        <Form.Item
          help={hasError ? error : null}
          className={classNames({ formItemError: hasError, formItemNoError: !hasError })}
          {...restProps}
        >
          {children}
        </Form.Item>
      )
    }}
  </Field>
)
